import { useInfiniteQuery } from '@tanstack/react-query';
import { findFirstAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
import { LIST_PROJECTS_ACTIONS } from './actionNames';
const DEFAULT_PAGE_SIZE = 50;
export function useListDLProjects({ searchTerm, status }) {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    // Owner gets `listDLProjects`, Agent gets `listAgentDLProjects` — same params and
    // response envelope. The resolved name keys the cache so personas never mix.
    const resolved = user ? findFirstAction(user, LIST_PROJECTS_ACTIONS) : null;
    const sendSearch = searchTerm.length >= 2 ? searchTerm : '';
    const sendStatus = status === 'all' ? '' : status;
    return useInfiniteQuery({
        queryKey: [resolved?.name ?? LIST_PROJECTS_ACTIONS[0], user?.email, sendSearch, sendStatus],
        enabled: Boolean(user && resolved),
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            const view = lastPage.response.filteredView;
            const total = view?.numberOfItems ?? 0;
            const pageSize = view?.pageSize ?? DEFAULT_PAGE_SIZE;
            const current = view?.currentPage ?? lastPage.page;
            if (current * pageSize >= total)
                return undefined;
            return current + 1;
        },
        queryFn: async ({ pageParam }) => {
            if (!user || !resolved)
                throw new Error('listDLProjects unavailable');
            const variables = {
                currentPage: String(pageParam),
                pageSize: String(DEFAULT_PAGE_SIZE),
            };
            if (sendSearch)
                variables.searchTerm = sendSearch;
            if (sendStatus)
                variables.status = sendStatus;
            const response = await invokeAction(resolved.action, user.token, { variables });
            if (!response.ok)
                throw new Error(`${resolved.name} returned ${response.status}`);
            const json = (await response.json());
            return { response: json, page: pageParam };
        },
    });
}
